module.exports = __webpack_public_path__ + "img/3e4a8aedff91c1e9e2ca9ee73106fe72.aa242c88.png";